import { useSelector } from 'react-redux';
import { ONLINE_ORDERING_BASE_PATH } from 'bento-ordering/base/constants/basePaths';
import { getBaseMenuPathForLocation } from 'bento-ordering/menus/selectors';

const useRedirectToOOMenu = () => {
  const baseMenuPath = useSelector(getBaseMenuPathForLocation);

  const redirectToOOMenu = () => {
    // Intentional full refresh here
    window.location.replace(`${ONLINE_ORDERING_BASE_PATH}${baseMenuPath}`);
  };

  return redirectToOOMenu;
};

export default useRedirectToOOMenu;
